"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckStatus = exports.CheckPaymentTransactionStatus = exports.CheckPaymentTransactionType = exports.CheckAuditLogModificationType = exports.CheckActionType = exports.CheckAuditLogActionType = exports.CheckMetadataType = exports.CheckPaymentStatus = exports.CheckPaymentErrorMethodType = exports.ValidateCheckPaymentErrorCode = exports.SalesLocationType = void 0;
var SalesLocationType;
(function (SalesLocationType) {
    SalesLocationType[SalesLocationType["None"] = 0] = "None";
    SalesLocationType[SalesLocationType["Table"] = 1] = "Table";
    SalesLocationType[SalesLocationType["Pos"] = 2] = "Pos";
    SalesLocationType[SalesLocationType["Express"] = 3] = "Express";
})(SalesLocationType = exports.SalesLocationType || (exports.SalesLocationType = {}));
var ValidateCheckPaymentErrorCode;
(function (ValidateCheckPaymentErrorCode) {
    ValidateCheckPaymentErrorCode["BalanceZero"] = "BALANCE_ZERO";
    ValidateCheckPaymentErrorCode["Expired"] = "EXPIRED";
    ValidateCheckPaymentErrorCode["TaxGroupsInvalid"] = "TAX_GROUPS_INVALID";
    ValidateCheckPaymentErrorCode["NoValidItems"] = "NO_VALID_ITEMS";
    ValidateCheckPaymentErrorCode["Inactive"] = "INACTIVE";
    ValidateCheckPaymentErrorCode["TaxGroupsMismatch"] = "TAX_GROUPS_MISMATCH";
    ValidateCheckPaymentErrorCode["CustomerNotLinked"] = "CUSTOMER_NOT_LINKED";
    ValidateCheckPaymentErrorCode["DiscountInvalid"] = "DISCOUNT_INVALID";
    ValidateCheckPaymentErrorCode["PaymentTypesInvalid"] = "PAYMENT_TYPES_INVALID";
    // ICoupons
    ValidateCheckPaymentErrorCode["ICouponTenderNotFound"] = "TENDER_NOT_FOUND";
    ValidateCheckPaymentErrorCode["ICouponTenderExpired"] = "TENDER_EXPIRED";
    ValidateCheckPaymentErrorCode["ICouponTenderAlreadyUsed"] = "TENDER_ALREADY_USED";
    ValidateCheckPaymentErrorCode["ICouponCannotPayWithThisTender"] = "INELIGIBLE_TENDER";
})(ValidateCheckPaymentErrorCode = exports.ValidateCheckPaymentErrorCode || (exports.ValidateCheckPaymentErrorCode = {}));
// Previously staged for deprecation. Now it's back.
// Refer - https://bitbucket.org/anconab/wildcat.client.types/pull-requests/279
var CheckPaymentErrorMethodType;
(function (CheckPaymentErrorMethodType) {
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["Terminal"] = 0] = "Terminal";
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["Mews"] = 1] = "Mews";
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["GiftCards"] = 2] = "GiftCards";
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["Wallets"] = 3] = "Wallets";
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["Cash"] = 4] = "Cash";
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["Invoice"] = 5] = "Invoice";
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["Custom"] = 6] = "Custom";
    CheckPaymentErrorMethodType[CheckPaymentErrorMethodType["Loyalty"] = 7] = "Loyalty";
})(CheckPaymentErrorMethodType = exports.CheckPaymentErrorMethodType || (exports.CheckPaymentErrorMethodType = {}));
/**
 * @deprecated Use `PaymentStatus` instead
 */
var CheckPaymentStatus;
(function (CheckPaymentStatus) {
    /** The payment doesn't have a status, it was just created */
    CheckPaymentStatus[CheckPaymentStatus["None"] = -1] = "None";
    /** The payment is processing the transaction */
    CheckPaymentStatus[CheckPaymentStatus["Processing"] = 0] = "Processing";
    /** The payment is completed and can be included in any calculations needed */
    CheckPaymentStatus[CheckPaymentStatus["Completed"] = 1] = "Completed";
    /** The payment failed for some reason */
    CheckPaymentStatus[CheckPaymentStatus["Error"] = 2] = "Error";
})(CheckPaymentStatus = exports.CheckPaymentStatus || (exports.CheckPaymentStatus = {}));
var CheckMetadataType;
(function (CheckMetadataType) {
    CheckMetadataType["GiftCard"] = "Giftcard";
    CheckMetadataType["ICoupon"] = "ICoupon";
    CheckMetadataType["Loyalty"] = "Loyalty";
    CheckMetadataType["Maitres"] = "Maitres";
    CheckMetadataType["Omniboost"] = "Omniboost";
    CheckMetadataType["PaymentProvider"] = "PaymentProvider";
    CheckMetadataType["Split"] = "Split";
    CheckMetadataType["Wallet"] = "Wallet";
    CheckMetadataType["StammyWallet"] = "StammyWallet";
    CheckMetadataType["PayAndGo"] = "PayAndGo";
    /** Client-side type but saved to DB and used in responses */
    CheckMetadataType["PayAndGoClientItemSelection"] = "PayAndGoClientItemSelection";
})(CheckMetadataType = exports.CheckMetadataType || (exports.CheckMetadataType = {}));
var CheckAuditLogActionType;
(function (CheckAuditLogActionType) {
    CheckAuditLogActionType[CheckAuditLogActionType["None"] = 0] = "None";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemQuantityChanged"] = 1] = "CheckItemQuantityChanged";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemPriceUpdate"] = 2] = "CheckItemPriceUpdate";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemMove"] = 3] = "CheckItemMove";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckSplit"] = 4] = "CheckSplit";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckDeleted"] = 5] = "CheckDeleted";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckCreated"] = 6] = "CheckCreated";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckPreviewPrinted"] = 7] = "CheckPreviewPrinted";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckTicketed"] = 8] = "CheckTicketed";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckDiscounted"] = 9] = "CheckDiscounted";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckMoved"] = 10] = "CheckMoved";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemAdded"] = 11] = "CheckItemAdded";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemRemoved"] = 12] = "CheckItemRemoved";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemSplit"] = 13] = "CheckItemSplit";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckMerged"] = 14] = "CheckMerged";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckPaymentCreated"] = 15] = "CheckPaymentCreated";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckPaymentCanceled"] = 16] = "CheckPaymentCanceled";
    CheckAuditLogActionType[CheckAuditLogActionType["WayOfPaymentAddedToOutlet"] = 17] = "WayOfPaymentAddedToOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["WayOfPaymentRemovedFromOutlet"] = 18] = "WayOfPaymentRemovedFromOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["WayOfPaymentCreated"] = 20] = "WayOfPaymentCreated";
    CheckAuditLogActionType[CheckAuditLogActionType["WayOfPaymentDeleted"] = 22] = "WayOfPaymentDeleted";
    CheckAuditLogActionType[CheckAuditLogActionType["VoucherBasisPublish"] = 23] = "VoucherBasisPublish";
    CheckAuditLogActionType[CheckAuditLogActionType["ProductPriceUpdate"] = 24] = "ProductPriceUpdate";
    CheckAuditLogActionType[CheckAuditLogActionType["TaxCreated"] = 25] = "TaxCreated";
    CheckAuditLogActionType[CheckAuditLogActionType["TaxDeleted"] = 26] = "TaxDeleted";
    CheckAuditLogActionType[CheckAuditLogActionType["TaxChanged"] = 27] = "TaxChanged";
    CheckAuditLogActionType[CheckAuditLogActionType["TaxAddedToOutlet"] = 28] = "TaxAddedToOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["TaxRemovedFromOutlet"] = 29] = "TaxRemovedFromOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["TaxUpdatedOnOutlet"] = 30] = "TaxUpdatedOnOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["FeeCreated"] = 31] = "FeeCreated";
    CheckAuditLogActionType[CheckAuditLogActionType["FeeDeleted"] = 32] = "FeeDeleted";
    CheckAuditLogActionType[CheckAuditLogActionType["FeeUpdated"] = 33] = "FeeUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["FeeAddedToOutlet"] = 34] = "FeeAddedToOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["FeeRemovedFromOutlet"] = 35] = "FeeRemovedFromOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["FeeUpdatedOnOutlet"] = 36] = "FeeUpdatedOnOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["ProductGroupCreated"] = 37] = "ProductGroupCreated";
    CheckAuditLogActionType[CheckAuditLogActionType["ProductGroupDeleted"] = 38] = "ProductGroupDeleted";
    CheckAuditLogActionType[CheckAuditLogActionType["ProductGroupUpdated"] = 39] = "ProductGroupUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["ProductGroupAddedToOutlet"] = 40] = "ProductGroupAddedToOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["ProductGroupUpdatedOnOutlet"] = 41] = "ProductGroupUpdatedOnOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["ProductGroupRemovedFromOutlet"] = 42] = "ProductGroupRemovedFromOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemModificationUpdated"] = 43] = "CheckItemModificationUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemKitchenMessageUpdated"] = 44] = "CheckItemKitchenMessageUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["WayOfPaymentUpdatedOnOutlet"] = 45] = "WayOfPaymentUpdatedOnOutlet";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemProductUpdated"] = 46] = "CheckItemProductUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemCourseUpdated"] = 47] = "CheckItemCourseUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemDiscountUpdated"] = 48] = "CheckItemDiscountUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["CreatedCheckTenantUserIdUpdated"] = 49] = "CreatedCheckTenantUserIdUpdated";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckForwarded"] = 50] = "CheckForwarded";
    CheckAuditLogActionType[CheckAuditLogActionType["CheckItemUnitQuantityChanged"] = 51] = "CheckItemUnitQuantityChanged";
})(CheckAuditLogActionType = exports.CheckAuditLogActionType || (exports.CheckAuditLogActionType = {}));
var CheckActionType;
(function (CheckActionType) {
    CheckActionType[CheckActionType["CreateCheck"] = 1] = "CreateCheck";
    CheckActionType[CheckActionType["DeleteCheck"] = 2] = "DeleteCheck";
    CheckActionType[CheckActionType["TicketCheck"] = 3] = "TicketCheck";
    CheckActionType[CheckActionType["CreateCollectionTicket"] = 4] = "CreateCollectionTicket";
    CheckActionType[CheckActionType["PreviewPrintCheck"] = 5] = "PreviewPrintCheck";
    CheckActionType[CheckActionType["ForwardCheck"] = 6] = "ForwardCheck";
    CheckActionType[CheckActionType["MergeCheck"] = 7] = "MergeCheck";
    CheckActionType[CheckActionType["SplitCheck"] = 8] = "SplitCheck";
    CheckActionType[CheckActionType["ChangeCheckDiscount"] = 9] = "ChangeCheckDiscount";
    CheckActionType[CheckActionType["AddCheckItems"] = 10] = "AddCheckItems";
    CheckActionType[CheckActionType["RemoveCheckItems"] = 11] = "RemoveCheckItems";
    CheckActionType[CheckActionType["MergeCheckItems"] = 12] = "MergeCheckItems";
    CheckActionType[CheckActionType["SplitCheckItems"] = 13] = "SplitCheckItems";
    CheckActionType[CheckActionType["MoveCheckItem"] = 14] = "MoveCheckItem";
    CheckActionType[CheckActionType["ChangeCheckItemQuantity"] = 15] = "ChangeCheckItemQuantity";
    CheckActionType[CheckActionType["ChangeCheckItemProduct"] = 16] = "ChangeCheckItemProduct";
    CheckActionType[CheckActionType["ChangeCheckItemPrice"] = 17] = "ChangeCheckItemPrice";
    CheckActionType[CheckActionType["UpdateCheckItemKitchenMessage"] = 18] = "UpdateCheckItemKitchenMessage";
    CheckActionType[CheckActionType["ChangeCheckItemCourse"] = 19] = "ChangeCheckItemCourse";
    CheckActionType[CheckActionType["ChangeCheckItemDiscount"] = 20] = "ChangeCheckItemDiscount";
    CheckActionType[CheckActionType["CalculateCheckItemUnitQuantity"] = 21] = "CalculateCheckItemUnitQuantity";
    CheckActionType[CheckActionType["ChangeCheckItemUnitQuantity"] = 22] = "ChangeCheckItemUnitQuantity";
    CheckActionType[CheckActionType["CreateMultiProduct"] = 23] = "CreateMultiProduct";
    CheckActionType[CheckActionType["CheckPayment"] = 24] = "CheckPayment";
    CheckActionType[CheckActionType["PosCheckPayment"] = 25] = "PosCheckPayment";
    CheckActionType[CheckActionType["ExpressCheckPayment"] = 26] = "ExpressCheckPayment";
    CheckActionType[CheckActionType["PayNGoPreviewPrintCheck"] = 27] = "PayNGoPreviewPrintCheck";
    CheckActionType[CheckActionType["PayNGoCheckPayment"] = 28] = "PayNGoCheckPayment";
    CheckActionType[CheckActionType["PayNGoSplitCheck"] = 29] = "PayNGoSplitCheck";
    CheckActionType[CheckActionType["PayNGoMergeCheck"] = 30] = "PayNGoMergeCheck";
    CheckActionType[CheckActionType["PayNGoDeleteCheck"] = 31] = "PayNGoDeleteCheck";
    CheckActionType[CheckActionType["PayNGoMoveCheckItem"] = 32] = "PayNGoMoveCheckItem";
})(CheckActionType = exports.CheckActionType || (exports.CheckActionType = {}));
var CheckAuditLogModificationType;
(function (CheckAuditLogModificationType) {
    CheckAuditLogModificationType["Add"] = "Add";
    CheckAuditLogModificationType["Remove"] = "Remove";
    CheckAuditLogModificationType["Replace"] = "Replace";
})(CheckAuditLogModificationType = exports.CheckAuditLogModificationType || (exports.CheckAuditLogModificationType = {}));
var CheckPaymentTransactionType;
(function (CheckPaymentTransactionType) {
    CheckPaymentTransactionType[CheckPaymentTransactionType["CancelOrRefund"] = -2] = "CancelOrRefund";
    CheckPaymentTransactionType[CheckPaymentTransactionType["Cancel"] = -1] = "Cancel";
    CheckPaymentTransactionType[CheckPaymentTransactionType["Authorize"] = 0] = "Authorize";
    CheckPaymentTransactionType[CheckPaymentTransactionType["AdjustAuthorization"] = 1] = "AdjustAuthorization";
    CheckPaymentTransactionType[CheckPaymentTransactionType["Action"] = 2] = "Action";
    CheckPaymentTransactionType[CheckPaymentTransactionType["Capture"] = 3] = "Capture";
    CheckPaymentTransactionType[CheckPaymentTransactionType["Refund"] = 4] = "Refund";
})(CheckPaymentTransactionType = exports.CheckPaymentTransactionType || (exports.CheckPaymentTransactionType = {}));
var CheckPaymentTransactionStatus;
(function (CheckPaymentTransactionStatus) {
    CheckPaymentTransactionStatus[CheckPaymentTransactionStatus["Error"] = -3] = "Error";
    CheckPaymentTransactionStatus[CheckPaymentTransactionStatus["Cancelled"] = -2] = "Cancelled";
    CheckPaymentTransactionStatus[CheckPaymentTransactionStatus["Refused"] = -1] = "Refused";
    CheckPaymentTransactionStatus[CheckPaymentTransactionStatus["Processing"] = 0] = "Processing";
    CheckPaymentTransactionStatus[CheckPaymentTransactionStatus["ActionRequired"] = 1] = "ActionRequired";
    CheckPaymentTransactionStatus[CheckPaymentTransactionStatus["Received"] = 2] = "Received";
    CheckPaymentTransactionStatus[CheckPaymentTransactionStatus["Success"] = 3] = "Success";
})(CheckPaymentTransactionStatus = exports.CheckPaymentTransactionStatus || (exports.CheckPaymentTransactionStatus = {}));
var CheckStatus;
(function (CheckStatus) {
    /**  Check was set in error by the system. */
    CheckStatus[CheckStatus["Error"] = -2] = "Error";
    /**  Check was canceled by customer, by outlet user or by system because of fail or other reasons */
    CheckStatus[CheckStatus["Cancelled"] = -1] = "Cancelled";
    /**  Check was created. */
    CheckStatus[CheckStatus["Created"] = 0] = "Created";
    /**  Payment started. */
    CheckStatus[CheckStatus["Processing"] = 1] = "Processing";
    /**  All payments are authorized */
    CheckStatus[CheckStatus["Authorized"] = 2] = "Authorized";
    /**  Check is partly paid. */
    CheckStatus[CheckStatus["PartlyPaid"] = 3] = "PartlyPaid";
    /**  Check is paid and closed. */
    CheckStatus[CheckStatus["Done"] = 4] = "Done";
})(CheckStatus = exports.CheckStatus || (exports.CheckStatus = {}));
